import React from "react";
import "./TermsAndConditions.css";

export const TermsAndConditions = () => {
  return (
    <div className="container">
      <div className="termsHeader mt-3">
        <h2>Terms & Conditions for Empathetic Listeners</h2>
        <p>
          <b> Effective Date: 1-Oct-25 </b> By enrolling in or offering services
          through Listen Aura India Private Limited (“Listen Aura”), you agree
          to abide by the following terms:
        </p>
      </div>
      <div className="termsContainer">
        <div className="terms-list-content">
          <div className="list-header">Code of Conduct</div>
          <div className="terms-content">
            <p>
              Treat every individual with respect, empathy, and non-judgment.
            </p>

            <p>
              Maintain strict confidentiality of all conversations, unless there
              is a risk of harm to the client or others.
            </p>

            <p>
              Do not offer medical or psychological diagnosis or advice unless
              you are a licensed mental health professional.
            </p>
          </div>
        </div>

        <div className="terms-list-content">
          <div className="list-header">Certification</div>
          <div className="terms-content">
            <p>
              Certification will only be granted upon successful completion of
              all training sessions, practice assessments, and final
              evaluations.
            </p>

            <p>
              You must uphold the standards, ethics, and communication practices
              taught during training.
            </p>
          </div>
        </div>

        <div className="terms-list-content">
          <div className="list-header">Use of Title</div>
          <div className="terms-content">
            <p>
              You may use the title “Trained Empathetic Listener – Listen Aura”
              only after receiving a certificate from the Listen Aura India Pvt
              Ltd.
            </p>

            <p>
              Misrepresentation of certification or services may result in
              revocation and legal action.
            </p>
          </div>
        </div>

        <div className="terms-list-content">
          <div className="list-header">Service Delivery</div>
          <div className="terms-content">
            <p>
              Services must remain strictly aligned with emotional support
              only-not therapy, treatment, or counselling.
            </p>

            <p>
              You must clearly disclose your role: “I am a trained empathetic
              listener, not a licensed therapist.”
            </p>
          </div>
        </div>

        <div className="terms-list-content">
          <div className="list-header">Confidentiality Agreement</div>
          <div className="terms-content">
            <p>All client information must remain strictly confidential.</p>

            <p>
              Any breach may result in immediate removal and possible legal
              consequences.
            </p>
          </div>
        </div>

        <div className="terms-list-content">
          <div className="list-header">Independent Service</div>
          <div className="terms-content">
            <p>
              Trained listeners are independent service providers, not employees
              of Listen Aura.
            </p>

            <p>
              Listen Aura is not liable for disputes, outcomes, or misconduct in
              sessions conducted outside its platform.
            </p>
          </div>
        </div>

        <div className="terms-list-content">
          <div className="list-header">Fee & Earning Ethics</div>
          <div className="terms-content">
            <p>
              Earnings must be based on transparent communication of time and
              fees.
            </p>

            <p>
              Clients must never be pressured into donations or paid sessions
              without prior agreement.
            </p>
          </div>
        </div>

        <div className="terms-list-content">
          <div className="list-header">Termination & Revocation</div>
          <div className="terms-content">
            <p>
              Violations of these terms, unethical conduct, or misuse of Listen
              Aura’s name may result in termination and blacklisting.
            </p>

            <p>Certification may be revoked at Listen Aura’s discretion.</p>
          </div>
        </div>

        <div className="terms-list-content">
          <div className="list-header">Amendments</div>
          <div className="terms-content">
            <p>
              Listen Aura reserves the right to update these Terms at any time.
              Continued association implies acceptance.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};
